/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import ApplicationRoutes from './application.routes';
import AddApplicationController from './add-application.controller';
import ApplicationDirective from './application.directive';
import ApplicationTableConfig from './application-table.config';

export default angular.module('tektelic.application', [])
    .config(ApplicationRoutes)
    .controller('AddApplicationController', AddApplicationController)
    .directive('tkApplication', ApplicationDirective)
    .factory('applicationTableConfig', ApplicationTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/application/index.js